import { ReactNode } from "react";

import Tooltip, { TooltipProps } from "@/components/ui/tooltip";

import { twMerge } from "tailwind-merge";

type Props = {
  children?: ReactNode;
  className?: string;
  onClick?: () => void;
  tooltipContent?: ReactNode;
  tooltipPosition?: TooltipProps["position"];
  disableTooltip?: boolean;
};

const MapMenuItemControl = ({
  children,
  className,
  onClick,
  tooltipContent,
  tooltipPosition = "left",
  disableTooltip = false,
  ...props
}: Props) => {
  const content = (
    <div
      className={twMerge(
        "flex justify-center items-center w-[40px] h-[40px] bg-white",
        className
      )}
      role="button"
      onClick={() => onClick?.()}
      tabIndex={0}
      onKeyDown={(e) => e.key === "Enter" && onClick?.()}
      {...props}
    >
      {children}
    </div>
  );

  if (!tooltipContent || disableTooltip) return content;

  return (
    <Tooltip content={tooltipContent} position={tooltipPosition}>
      {content}
    </Tooltip>
  );
};

export default MapMenuItemControl;
